import './index.scss'

export default (props) => 
<div className={`divider ${props.className}`}>
        {props.label && <div className="label">{props.label}</div>}
</div>